import { render, staticRenderFns } from "./InformacionPagoV2.vue?vue&type=template&id=f0c0ee7c&scoped=true"
import script from "./InformacionPagoV2.vue?vue&type=script&setup=true&lang=js"
export * from "./InformacionPagoV2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InformacionPagoV2.vue?vue&type=style&index=0&id=f0c0ee7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c0ee7c",
  null
  
)

export default component.exports